import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContractTermsAgencyModel } from 'src/app/Model/ContractTermsAgency.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { ContractsService } from 'src/app/Services/contracts/contracts.service';
import { DocumentService } from 'src/app/Services/document/Documentservice';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { RequesStatusService } from "src/app/Services/RequestStatus/RequesStatus.service";
import Swal from 'sweetalert2';

@Component({
  selector: 'app-application-approval',
  templateUrl: './application-approval.component.html',
  styleUrls: ['./application-approval.component.css']
})
export class ApplicationApprovalComponent implements OnInit {

  private requestCode : string;
  public Request: RequestModel;
  public documentsReady: boolean;
  public isRejected: boolean;
  public inRevision: boolean;
  public contractAvailable: boolean;
  public ContractTermsAgency: ContractTermsAgencyModel;
  public activeLang = 'es';
  public redirectBool: boolean;
  public lang : string;
  public TCBool: boolean;
  
  constructor(
    private readonly activeRoute: ActivatedRoute,
    private readonly SpinnerService: NgxSpinnerService,
    private readonly Service: DocumentService,
    private readonly translate: TranslateService,
    private readonly DocumentService: DocumentService,
    private readonly RequesStatusService: RequesStatusService,
    private readonly Service2: ContractsService,
    private readonly lsService : SessionStorageService
    ) { }

   async ngOnInit() {

    if(this.lsService.getLSItem('language') == null){
      this.lang = this.activeLang
    }
    else{
      this.lang = this.lsService.getLSItem('language')
    }
    
    if(this.activeRoute.snapshot.params.requestcode == undefined){
      this.requestCode = this.lsService.getLSItem('RequestCode')
    }
    else{
      this.requestCode = this.activeRoute.snapshot.params.requestcode;
    }
     this.GetRequestByCode()
  }

  redirectAcceptTerms() {
    window.location.replace(`Register/Main/AcceptTerms`);
  }

  redirectHome() {
    window.location.replace("Register/Main/Home?type=" + this.lsService.getLSItem('type'));
  }

  public async GetRequestByCode() {
    if (this.requestCode != undefined) {
      this.SpinnerService.show()

      await this.Service.getRequestByCode(this.requestCode).then(
         async (res) => {
          this.Request = res;
          
          await this.getRequestStatus(this.Request.Id)

          await this.validateDocuments()
          this.SpinnerService.hide()
          if(!this.documentsReady && !this.contractAvailable){
            Swal.fire({
              icon: "error",
              title: this.translate.instant("Main.Documents"),
              showConfirmButton: false,
              showCloseButton: true,
              timer: 3000,
            }).then((res) => {
              window.location.replace(`Register/Main/Request`);
            })
          }
          if(this.Request.IdFlow == 2 || this.Request.IdFlow == 4 || this.Request.IdFlow == 5 || this.Request.IdFlow == 6 || this.Request.IdFlow == 7 || this.Request.IdFlow == 8 || this.Request.IdFlow == 14 || this.Request.IdFlow == 17 || this.Request.IdFlow == 18){
            this.TCBool = true
          }
          else{
            this.TCBool = false
          }

          this.lsService.setLSItem('RequestCode',this.Request.RequestCode)
          this.lsService.setLSItem('IdRequest',this.Request.Id.toString())
          this.lsService.setLSItem('type',this.Request.ConnectionType.toString())
          
          if (this.Request == undefined) {
              Swal.fire({
                icon: "error",
                title: this.translate.instant("Document.Messages.2"),
                showConfirmButton: false,
                timer: 3000,
              }).then(res => {
                this.redirectHome()
              });

          } 
          else {
            if (this.Request.RequestIdentification.length != 0) {
            } else {         
                Swal.fire({
                  icon: "error",
                  title: this.translate.instant("Document.Messages.7"),
                  showConfirmButton: false,
                  timer: 3000,
                }).then(res => {
                  this.redirectHome()
                });
            }
          }
        }
      );
    } else {
      Swal.fire({
        icon: "error",
        title: this.translate.instant('Document.Messages.5'),
        showConfirmButton: false,
        timer: 3000,
      }).then(res => {
        this.redirectHome()
      });
    }
    
  }
  
  public async checkIfrequestIsRejected(idrequest){
    await this.RequesStatusService.checkIfRequestIsRejected(idrequest).then(resp => {
        this.isRejected = resp  
    })
  }


  //el resultado de este llamado determina si la solicitud ya generó el contrato o no. En caso de flujos que no tengan contrato, indica si la solicitud está terminada o no
  public async getRequestStatus(idrequest){
    await this.DocumentService.getDocumentsApproval(idrequest).then(resp => {
      this.contractAvailable = resp.Approved
      if(!this.contractAvailable){
        //si el contrato no está disponible, se revisa si la solicitud está rechazada
        this.checkIfrequestIsRejected(idrequest)
        this.inRevision = this.isRejected == true ? false : true
      }    
      else{
        this.isRejected = false
        this.inRevision = false
      }
    })
  }

  public async validateDocuments(){
    
    let docsReady = this.inRevision

    await this.DocumentService.GetStatusDocumentUpdatedByIdRequest(this.Request.Id).then(async (resp) =>{
      let updatedDocumentStatus = resp
      if(updatedDocumentStatus.length != 0){
        updatedDocumentStatus.forEach(x => {
          if(x.Approve != true && x.ReviewDocument != true){
            docsReady = false
          }
        })
      }
      this.documentsReady = docsReady
    })
    
  }
}
